import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getPurchaseCreditNote,
  getPurchaseCreditNoteById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  createPurchaseCreditNote,
  getPurchaseCreditNoteDetailsById,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  purchaseCreditNotes: [],
  edit: false,
  purchaseCreditNote: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseCreditNote: false,
  loadingNext: false,
  saveAndContinue: false,
  purchaseCreditNoteDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
      noEffectInventory: false,
    },
  ],
  showCreateModal: false,
  selectedPurchaseInvoice: null,
  selectedPurchaseInvoiceDetails: [],
};

export const purchaseCreditNoteSlice = createSlice({
  name: "purchaseCreditNote",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setPurchaseInvoice: (state, action) => {
      state.selectedPurchaseInvoice = action.payload;
    },
    setSelectedInvoiceDetails: (state, action) => {
      state.selectedPurchaseInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },

    setPurchaseCreditNote: (state, action) => {
      state.purchaseCreditNote = action.payload;
    },
    purchaseCreditNoteDetailsUpdated: (state, action) => {
      state.purchaseCreditNoteDetails = action.payload.map((value) => {
        return { ...value, description: value.product?.name, unique: uuidv4() };
      });
    },
    clearSelectedOrderData: (state) => {
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
    },

    clearPurchaseCreditNoteDetails: (state) => {
      state.purchaseCreditNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
    },
    clearAllPurchaseCreditNote: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseCreditNote = false;
      state.purchaseCreditNote = null;
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
      state.purchaseCreditNoteDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
          noEffectInventory: false,
        },
      ];
    },
  },
  extraReducers: (builder) => {
    // getPurchaseCreditNoteById
    builder.addCase(getPurchaseCreditNoteById.pending, (state) => {
      state.loading = true;
      state.purchaseCreditNote = null;
    });
    builder.addCase(getPurchaseCreditNoteById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.purchaseCreditNote = action.payload.data;
      state.purchaseCreditNoteDetails = action.payload.data?.drCrNotesDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getPurchaseCreditNoteById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseCreditNote = null;
    });

    builder.addCase(getPurchaseCreditNoteDetailsById.pending, (state) => {
      state.loading = true;
      state.purchaseCreditNote = null;
    });
    builder.addCase(getPurchaseCreditNoteDetailsById.fulfilled, (state, action) => {
      state.loading = false;
      state.purchaseCreditNote = action.payload.data;
      // state.purchaseCreditNoteDetails = action.payload.data?.purchaseInvoiceDetail?.map((value) => {
      //   return { ...value, unique: uuidv4(), noEffectInventory: false };
      // });
    });
    builder.addCase(getPurchaseCreditNoteDetailsById.rejected, (state) => {
      state.loading = false;
      state.purchaseCreditNote = null;
    });

    builder.addMatcher(
      isAnyOf(
        getPurchaseCreditNote.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseCreditNote = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseCreditNote.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseCreditNote = false;
        state.purchaseCreditNotes = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseCreditNote.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseCreditNote = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setPurchaseInvoice,
  setSelectedInvoiceDetails,
  setPurchaseCreditNote,
  purchaseCreditNoteDetailsUpdated,
  clearSelectedOrderData,
  clearPurchaseCreditNoteDetails,
  clearAllPurchaseCreditNote,
} = purchaseCreditNoteSlice.actions;

export default purchaseCreditNoteSlice.reducer;
